import { confirm } from "devextreme/ui/dialog";
import { useContext } from "react";
import { AR, FileTypes, ROType } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitVerificationForm } from "../api/submit-verification-form";
import { RetailOrderContext } from "../context/RetailOrderContext";
import PhotoReferenceGuideLink from "./PhotoReferenceGuideLink";
import RetailOrderFiles from "./RetailOrderFiles";

export default function WorkVerificationFormFiles() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const submitForm = useSubmitVerificationForm(
		order.details.retailOrderID,
		() => {
			showSuccessMessage('Files have been submitted');
			refetchOrder();
		},
		(error) => showErrorMessage(error)
	);

	if (order.details.roTypeID === ROType.CabinetInstallOrder) {
		return (
			<>
				<PhotoReferenceGuideLink />
				<RetailOrderFiles
					fileTypes={[FileTypes.DisplayPhoto]}
					defaultFileType={FileTypes.DisplayPhoto}
					buttonCaption={'Upload Photos'}
				/>

				<RetailOrderFiles
					fileTypes={[FileTypes.WorkVerificationForm]}
					defaultFileType={FileTypes.WorkVerificationForm}
					buttonCaption={order.details.activeARs.includes(AR.InstallerToUploadVerificationForm) ?
						`Upload Work Verification Form` : undefined}
					onFileAdded={(fileType: FileTypes) => {
						if (fileType === FileTypes.WorkVerificationForm &&
							order.details.files.find(x => x.fileTypeID === FileTypes.DisplayPhoto)) {
							confirm("Do you want to submit the file?", "Submit File")
								.then((result) => {
									if (result) {
										submitForm.mutate();
									}
								});
						}
					}}
				/>
			</>
		)
	}
	else {
		return (
			<RetailOrderFiles
				fileTypes={[FileTypes.WorkVerificationForm]}
				defaultFileType={FileTypes.WorkVerificationForm}
				buttonCaption={order.details.activeARs.includes(AR.InstallerToUploadVerificationForm) ?
					`Upload Work Verification Form` : undefined}
				onFileAdded={(fileType: FileTypes) => {
					if (fileType === FileTypes.WorkVerificationForm) {
						confirm("Do you want to submit the file?", "Submit File")
							.then((result) => {
								if (result) {
									submitForm.mutate();
								}
							});
					}
				}}
			/>
		)
	}
}
